import moment from 'moment';

// Display helpers shared by <script setup> pages (the legacy mixin has the
// same ones, but setup code can't reach it).

export const titleCase = (s) =>
  String(s ?? '').replace(/\w\S*/g, (w) => w[0].toUpperCase() + w.slice(1).toLowerCase());

export const formatDate = (date, format = 'MMM D, YYYY') =>
  date ? moment(date).format(format) : '';

export const formatDateTime = (date, format = 'MMM D, YYYY h:mm A') =>
  date ? moment(date).format(format) : '';

export const formatTime = (time, format = 'h:mm A') =>
  time ? moment(time, 'HH:mm:ss').format(format) : '';

// "8:00 AM – 9:00 AM" from two "HH:mm[:ss]" times, or from the
// "08:00:00 - 09:00:00" text the schedule endpoints send as one value.
export const formatTimeRange = (from, to) => {
  const [a, b] = to === undefined ? String(from ?? '').split(/\s+-\s+/) : [from, to];
  return [a, b].filter(Boolean).map((t) => formatTime(t)).join(' – ');
};

// yyyy-mm-dd for <input type="date">.
export const isoDate = (date) => (date ? moment(date).format('YYYY-MM-DD') : '');

// A schedule cell's "Subject, Section" → { subject, section }. Split at the
// last comma, so a subject title that has a comma of its own stays whole.
export function splitClass(value) {
  const text = String(value ?? '').trim();
  const at = text.lastIndexOf(', ');
  return at === -1 ? { subject: text, section: '' } : { subject: text.slice(0, at), section: text.slice(at + 2) };
}

// Two-letter initials for an avatar.
export const initials = (name) =>
  String(name ?? '')
    .split(/[\s,]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('');

// [{ id: 1, name: 'January' }, …] for month pickers (ids match the API).
export const MONTHS = moment.months().map((name, i) => ({ id: i + 1, name }));

// School days, as the schedule endpoints name their columns.
export const WEEKDAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
